import React from 'react'
import s from './PlzSelectSection.module.scss'

export const PlzSelectSection = () => {
    return (
        <div className={s.plzSelect}>
            Please select section
        </div>
    )
}